import { render, staticRenderFns } from "./ClientOrder.vue?vue&type=template&id=d438517a&lang=pug"
import script from "./ClientOrder.vue?vue&type=script&lang=js"
export * from "./ClientOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports